import React from 'react'

function CallAssistance({ closeCallback }) {
    return (
        <div class="assistance-popup active">
            <div class="assistance-popup-inner">
                <p>Your request has been sent. Someone will attend you shortly</p>
                <div class="action text-center mt-10"><button class="btn bg-dark" onClick={closeCallback}>OK</button></div>
            </div>
        </div>
    )
}

export default CallAssistance
